import { makeStyles } from '@material-ui/core/styles'

export const useBulkTableStyles = makeStyles(theme => ({
  tableWrapper: {
    borderRadius: 12,
    border: '1px solid #eef0f4',
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
    margin: `${theme.spacing(2)}px auto 0`
  },
  table: {
    width: '100%',
    borderCollapse: 'separate',
    borderSpacing: '0 8px',
    '& th': {
      background: '#f8f9fb',
      color: '#546e7a',
      fontSize: 13,
      fontWeight: 600,
      padding: '12px 14px',
      textAlign: 'left',
      verticalAlign: 'top'
    },
    '& td': {
      background: '#f5f6f8',
      color: '#263238',
      fontSize: 13,
      padding: '10px 14px',
      textAlign: 'left',
      verticalAlign: 'middle'
    }
  },
  compactTable: {
    borderSpacing: '0 4px',
    '& th:first-child, & td:first-child': {
      minWidth: 250
    },
    '& th': {
      padding: '10px'
    },
    '& td': {
      padding: '6px 10px'
    }
  },
  stickyHeader: {
    '& th': {
      position: 'sticky',
      top: 150,
      zIndex: 11,
      boxShadow: '0 6px 8px -8px rgba(38, 50, 56, 0.45)'
    }
  },
  storeName: {
    fontWeight: 600,
    minWidth: 180,
    textAlign: 'left'
  },
  applyRow: {
    display: 'flex',
    gap: 6,
    marginTop: 6,
    alignItems: 'center'
  },
  applyButton: {
    height: 40,
    minWidth: 34,
    padding: 0
  },
  compactApplyButton: {
    height: 34,
    minWidth: 30
  },
  input: {
    minWidth: 120,
    maxWidth: 165,
    width: '100%',
    '& .MuiOutlinedInput-root': {
      background: '#fff',
      height: 40
    },
    '& .MuiInputBase-input': {
      padding: '8px 10px'
    }
  },
  compactInput: {
    minWidth: 105,
    maxWidth: 145,
    '& .MuiOutlinedInput-root': {
      height: 34
    },
    '& .MuiInputBase-input': {
      padding: '6px 8px'
    }
  },
  headerSelect: {
    minWidth: 128,
    '& .MuiSelect-select': {
      paddingTop: 8,
      paddingBottom: 8
    }
  }
}))
